<template>
  <div>
    <AudioPlayer
      :visible="audioPlayerVisible"
      :audio-url="currentAudio.url"
      :title="currentAudio.title"
      :origin="currentAudio.origin"
      :destination="currentAudio.destination"
      :date="currentAudio.date"
      @update:visible="audioPlayerVisible = $event"
    />
  </div>
</template>

<script lang="jsx">
import { mapGetters } from "vuex";
import { CLEARED_NOTIFICATION, NEW_NOTIFICATION } from "@/events/constants";
import { Notification } from "element-ui";
import {
  IGNORE_ALARM_NOTIFICATIONS_WGS,
  NOTIFICATION_TYPE_ALARM,
  NOTIFICATION_TYPE_GIVE_BACK,
  NOTIFICATION_TYPE_NO_CLIENT,
  NOTIFICATION_TYPE_PTT,
  NOTIFICATION_TYPE_STREET_ERRORS,
  NOTIFICATION_TYPE_VOICE,
  NOTIFICATION_TYPE_ZONES_ERRORS,
} from "@/utils/constants";
import notifications from "@/mixins/notifications";
import AcceptGiveBackButton from "@/components/common/AcceptGiveBackButton.vue";
import AudioPlayer from "@/components/common/AudioPlayer";
import { downloadPushToTalk, parsePttFile } from "@/modules/pushtotalk/utils/s3.ts";

export default {
  name: "NotificationMessage",
  mixins: [notifications],
  components: {
    AudioPlayer,
  },
  computed: {
    ...mapGetters("app", ["taxis", "defaultWorkgroup"]),
    ...mapGetters("operators", ["userHasManagementPermission"]),
  },
  data() {
    return {
      messages: {},
      audioPlayerVisible: false,
      currentAudio: {
        url: "",
        title: "",
        origin: "",
        destination: "",
        date: new Date(),
      },
    };
  },
  destroyed() {
    this.$bus.unsubscribe("notification-message");
  },
  created() {
    this.$bus.subscribe({
      id: "notification-message",
      handle: (event, payload) => {
        const silentNotifications = [];
        if (window.localStorage.getItem("SILENT_NOTIFICATIONS") === "true") {
          silentNotifications.push(NOTIFICATION_TYPE_STREET_ERRORS);
          silentNotifications.push(NOTIFICATION_TYPE_ZONES_ERRORS);
        }

        if (silentNotifications.includes(payload?.type)) {
          return;
        }

        let message = "";
        let license = "";
        let address = "";
        let onclick;

        switch (event) {
          case NEW_NOTIFICATION:
            license = this.taxis.find(
              (t) => t.id === payload.idTaxi && t.idWorkgroup === payload.idWg
            )?.license;
            console.log(license);
            setTimeout(() => {
              switch (payload.type) {
                case NOTIFICATION_TYPE_ALARM:
                  if (IGNORE_ALARM_NOTIFICATIONS_WGS.includes(this.defaultWorkgroup.id)) {
                    return;
                  }
                  message = `Alarma ${license}`;
                  onclick = () => {
                    this.handleNotificationClick(payload);
                  };
                  break;
                case NOTIFICATION_TYPE_VOICE:
                  message = `Paso por voz ${license}`;
                  onclick = () => {
                    this.handleNotificationClick(payload);
                  };
                  break;
                case NOTIFICATION_TYPE_PTT:
                  message = `Push to talk de ${license}`;
                  onclick = () => {
                    this.handlePTTClick(payload);
                  };
                  break;
                case NOTIFICATION_TYPE_NO_CLIENT:
                  address = this.getAddress(payload);
                  message = this.$createElement(
                    "div",
                    {
                      style:
                        "display: flex; justify-content: center; flex-direction: column; margin-top: 3px",
                    },
                    [
                      this.$createElement(
                        "div",
                        {
                          style: "display: flex; align-items: center; justify-content: center",
                        },
                        [
                          this.$createElement(
                            "div",
                            {
                              style:
                                "padding-right: 10px; padding-bottom: 4px; margin-right: 10px;",
                              domProps: {
                                onclick: () => this.handleNotificationClick(payload),
                              },
                            },
                            [
                              this.$createElement(
                                "span",
                                { style: "font-weight: bold" },
                                `Ausencia ${license}`
                              ),
                              this.$createElement("br"),
                              this.$createElement(
                                "span",
                                { style: "font-weight: normal" },
                                address
                              ),
                            ]
                          ),
                          this.$createElement(
                            "div",
                            {
                              class: "material-icons m-icon-m danger",
                              style: "height: 29px",
                              role: "button",
                              domProps: {
                                onclick: (ev) => this.acceptNoClient(payload, ev),
                              },
                            },
                            "check_circle"
                          ),
                          this.$createElement(
                            "div",
                            {
                              class: "material-icons m-icon-m danger",
                              style: "height: 29px",
                              role: "button",
                              domProps: {
                                onclick: (ev) => this.rejectNoClient(payload, ev),
                              },
                            },
                            "cancel"
                          ),
                        ]
                      ),
                      this.$createElement("div", { style: "font-size: 12px" }, payload.address),
                    ]
                  );
                  onclick = () => {
                    this.openService(payload);
                  };
                  break;
                case NOTIFICATION_TYPE_GIVE_BACK:
                  address = this.getAddress(payload);
                  message = this.$createElement(
                    "div",
                    {
                      style:
                        "display: flex; justify-content: center; flex-direction: column; margin-top: 3px",
                    },
                    [
                      this.$createElement(
                        "div",
                        {
                          style: "display: flex; align-items: center; justify-content: center",
                        },
                        [
                          this.$createElement(
                            "div",
                            {
                              style:
                                "padding-right: 10px; padding-bottom: 4px; margin-right: 10px;",
                              domProps: {
                                onclick: () => this.handleNotificationClick(payload),
                              },
                            },
                            [
                              this.$createElement(
                                "span",
                                { style: "font-weight: bold" },
                                `Devolución ${license}`
                              ),
                              this.$createElement("br"),
                              this.$createElement(
                                "span",
                                { style: "font-weight: normal" },
                                address
                              ),
                            ]
                          ),
                          this.$createElement(
                            AcceptGiveBackButton,
                            {
                              props: {
                                notification: payload,
                                onClose: this.refreshNotifications,
                                store: this.$store,
                              },
                              instance: this,
                            },
                            [
                              this.$createElement(
                                "div",
                                { class: "material-icons m-icon-m success" },
                                "check_circle"
                              ),
                            ]
                          ),
                          this.$createElement(
                            "div",
                            {
                              class: "material-icons m-icon-m danger",
                              style: "height: 29px",
                              role: "button",
                              domProps: {
                                onclick: (ev) => this.rejectGiveBack(payload, ev),
                              },
                            },
                            "cancel"
                          ),
                        ]
                      ),
                      this.$createElement("div", { style: "font-size: 12px" }, payload.address),
                    ]
                  );
                  break;
                case NOTIFICATION_TYPE_STREET_ERRORS:
                  if (!this.userHasManagementPermission) {
                    return;
                  }
                  message = this.$createElement(
                    "div",
                    { style: "display: flex; align-items: center;" },
                    [
                      this.$createElement("div", { style: "padding-right: 12px;" }, [
                        this.$createElement("i", {
                          class: "fas fa-exclamation-triangle fa-fw fa-2x",
                        }),
                      ]),
                      this.$createElement("div", null, [
                        this.$createElement("strong", "Hay errores en las calles"),
                        this.$createElement("br"),
                        this.$createElement(
                          "span",
                          { style: "font-weight: normal" },
                          "Haz click para ir a gestión de calles y solucionarlo"
                        ),
                      ]),
                    ]
                  );
                  onclick = () => {
                    this.$router.push("/manager/streets");
                    this.messages[payload.inserted]?.close();
                  };
                  break;
                case NOTIFICATION_TYPE_ZONES_ERRORS:
                  if (!this.userHasManagementPermission) {
                    return;
                  }
                  message = this.$createElement(
                    "div",
                    { style: "display: flex; align-items: center;" },
                    [
                      this.$createElement("div", { style: "padding-right: 12px;" }, [
                        this.$createElement("i", {
                          class: "fas fa-exclamation-triangle fa-fw fa-2x",
                        }),
                      ]),
                      this.$createElement("div", null, [
                        this.$createElement(
                          "strong",
                          "Hay errores en las zonas. Revisa que todas tenga un reparto por defecto."
                        ),
                        this.$createElement("br"),
                        this.$createElement(
                          "span",
                          { style: "font-weight: normal" },
                          "Haz click para ir a gestión de zonas y paradas y solucionarlo"
                        ),
                      ]),
                    ]
                  );
                  onclick = () => {
                    this.$router.push("/manager/zones-stops");
                    this.messages[payload.inserted].close();
                  };
                  break;
              }
              // Prevent to show the same notification multiple times
              if (!this.messages[payload.inserted]) {
                this.messages[payload.inserted] = Notification({
                  message,
                  showClose: true,
                  customClass: `notification type-${payload.type}`,
                  duration: 0,
                  offset: 50,
                  onClick: onclick,
                  onClose: () => {
                    delete this.messages[payload.inserted];
                  },
                });
              }
            }, 10);
            break;
          case CLEARED_NOTIFICATION:
            if (this.messages[payload.inserted]) {
              this.messages[payload.inserted].close();
              delete this.messages[payload.inserted];
            }
            break;
        }
      },
    });
  },
  methods: {
    getAddress(notification) {
      try {
        return JSON.parse(notification.params).streetFromText;
      } catch (e) {
        return "N/A";
      }
    },
    async handlePTTClick(payload) {
      const ptt = parsePttFile(payload.params.url);

      const audio = await downloadPushToTalk(ptt.key);
      const audioUrl = URL.createObjectURL(audio);

      this.currentAudio = {
        url: audioUrl,
        title: ptt.title,
        origin: ptt.origin,
        destination: ptt.destination,
        date: ptt.date,
      };
      this.audioPlayerVisible = true;
      this.dismissNotification(payload);
    },
  },
};
</script>

<style>
.notification {
  right: 10px;
  left: auto;
  transform: none;
  min-width: 100px;
  width: auto;
  padding: 10px 25px 10px 0;
}

.notification .el-notification__content {
  margin-top: 0;
  font-weight: bold;
  color: white;
  cursor: pointer;
}

.notification .el-notification__closeBtn {
  top: 12px;
  right: 10px;
  color: white;
}

.notification.type-1 {
  /* alarm */
  background-color: rgba(200, 0, 0, 1);
  border-color: rgba(200, 0, 0, 1);
}

.notification.type-2 {
  /* voice */
  background-color: rgba(48, 106, 213, 1);
  border-color: rgba(48, 106, 213, 1);
}

.notification.type-3 {
  /* no client */
  background-color: rgba(130, 0, 195, 1);
  border-color: rgba(130, 0, 195, 1);
}

.notification.type-4 {
  /* give back */
  background-color: rgba(255, 165, 0, 1);
  border-color: rgba(255, 165, 0, 1);
}

.notification.type-5 {
  /* give back */
  background-color: rgb(81, 193, 0);
  border-color: rgb(81, 193, 0);
}

.notification.type-10 {
  /* street error */
  background-color: rgba(200, 0, 0, 1);
  border-color: rgba(200, 0, 0, 1);
}

.notification.type-11 {
  /* street error */
  background-color: rgb(200, 100, 0);
  border-color: rgb(200, 70, 0);
}

.notification-address {
  font-weight: normal;
}
</style>
